import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
var numeral = require("numeral");
import formatDate from './mixins/formatDate';
import mixinExcel from './mixins/mixinexcel';

import store from './store'

Vue.mixin(formatDate);
Vue.mixin(mixinExcel);

Vue.config.productionTip = false

Vue.filter('formatearFechaHora', (laFecha) => {
  //var tzoffset = laFecha.getTimezoneOffset() * 60000; //offset in milliseconds
  var localISOTime = laFecha.toISOString();
  const [yyyy, mm, dd, hh, nn, ss] = localISOTime.split(/[T:\-.\s]/g)
  return `${dd}/${mm}/${yyyy} ${hh}:${nn}:${ss}`  
})
Vue.filter('formatearFecha', (laFecha) => {
  var localISOTime = laFecha.toISOString();
  const [yyyy, mm, dd] = localISOTime.split(/[T:\-.\s]/g)
  return `${dd}/${mm}/${yyyy}`  
})
Vue.filter('formatearHora', (laFecha) => {
  var localISOTime = laFecha.toISOString();
  // eslint-disable-next-line
  const [yyyy, mm, dd, hh, nn, ss] = localISOTime.split(/[T:\-.\s]/g)
  return `${hh}:${nn}:${ss}`  
})
Vue.filter("formatNumber", function (value) {
  return numeral(value).format("0,000"); // displaying other groupings/separators is possible, look at the docs
});

window.serverInfoGG = localStorage.getItem("serverInfo")

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
